// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3A5Yv","fade-in":"styles_fade-in__rP6q6","border":"styles_border__2tu98","logo":"styles_logo__2V47j","backButton":"styles_backButton__1vg-c"};